export const FETCH_PENDING_SELF_PROMOTIONS =
  'selfPromotion/FETCH_PENDING_SELF_PROMOTIONS';
export const SET_PENDING_SELF_PROMOTIONS =
  'selfPromotion/SET_PENDING_SELF_PROMOTIONS';
export const SET_PENDING_SELF_PROMOTIONS_LOADING =
  'selfPromotion/SET_PENDING_SELF_PROMOTIONS_LOADING';
export const SET_PENDING_SELF_PROMOTIONS_ERROR =
  'selfPromotion/SET_PENDING_SELF_PROMOTIONS_ERROR';

export const ANSWER_SELF_PROMOTION = 'selfPromotion/ANSWER_SELF_PROMOTION';
export const SET_ANSWERING_SELF_PROMOTION =
  'selfPromotion/SET_ANSWERING_SELF_PROMOTION';
export const SET_ANSWER_SELF_PROMOTION_ERROR =
  'selfPromotion/SET_ANSWER_SELF_PROMOTION_ERROR';
export const REMOVE_PENDING_SELF_PROMOTION =
  'selfPromotion/REMOVE_PENDING_SELF_PROMOTION';
